import { message, Form as FormInitial, Tooltip, Alert, Select, Modal } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  SwitchItem,
  SelectInsumosItem,
  TextAreaItem,
  ErrorItem,
  dineroDisabledMask,
  round6Decimals,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import {
  PlusOutlined,
  MinusCircleOutlined,
  WarningOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";

const carecVentaOnline = (insumo) =>
  insumo &&
  (!insumo.venta || !insumo.ventaOnline || insumo.estado !== 1);

// Precio unitario del insumo para el nivel de precio indicado. Sin match →
// null (mismo criterio que el PDF de la lista, que imprime "—"): no hay
// fallback a otro nivel de precio.
const precioUnitarioNivel = (insumo, nivelPrecioId) => {
  if (!nivelPrecioId || !Array.isArray(insumo?.precios)) return null;
  const encontrado = insumo.precios.find(
    (p) => String(p.precioId) === String(nivelPrecioId)
  );
  return encontrado && encontrado.precio != null
    ? Number(encontrado.precio)
    : null;
};

// Impuestos de un renglón, desglosados por impuesto. Mismo cálculo que
// AgregarVenta/VerVenta (y que impuestoPorUnidad del backend) para que los
// totales coincidan con la columna "Precio al Público" de la tabla de listas.
const impuestosFila = (subtotalFila, cantidad, impuestos) => {
  if (!Array.isArray(impuestos) || impuestos.length === 0) {
    return { totalImpuestos: 0, desglose: [] };
  }
  const tipoDeCambio = 1;
  let totalImpuestos = 0;
  const desglose = impuestos.map((imp) => {
    let totalImpuesto = 0;
    if (imp.tasaCuota === 1) {
      totalImpuesto = round6Decimals(subtotalFila * (imp.monto / 100));
    } else if (imp.tasaCuota === 2) {
      totalImpuesto = round6Decimals(
        (subtotalFila + totalImpuestos) * (imp.monto / 100)
      );
    } else if (imp.tasaCuota === 3) {
      totalImpuesto = round6Decimals((cantidad * imp.monto) / tipoDeCambio);
    } else if (imp.tasaCuota === 5) {
      totalImpuesto = 0;
    }
    totalImpuestos += totalImpuesto;
    return {
      descripcionFactura: imp.descripcionFactura || imp.nombre || "Impuesto",
      totalImpuestos: totalImpuesto,
    };
  });
  return { totalImpuestos, desglose };
};

// Subtotal / impuestos / total de un renglón. null = el insumo no tiene
// precio en esa lista de precios.
const totalesFila = (fila, insumosPrecargados, nivelPrecioId) => {
  if (!fila?.insumoId) return null;
  const insumo = insumosPrecargados[String(fila.insumoId)];
  const precioUnitario = precioUnitarioNivel(insumo, nivelPrecioId);
  if (precioUnitario === null) return null;
  const cantidad = Number(fila.cantidad || 0);
  const subtotal = round6Decimals(cantidad * precioUnitario);
  const { totalImpuestos, desglose } = impuestosFila(
    subtotal,
    cantidad,
    insumo?.impuestos
  );
  return {
    precioUnitario,
    subtotal,
    impuestos: totalImpuestos,
    total: subtotal + totalImpuestos,
    desglose,
  };
};

const calcularTotalesLista = (filas, insumosPrecargados, nivelPrecioId) => {
  let costoTotal = 0;
  let subtotal = 0;
  let sinPrecio = 0;
  const mapaImpuestos = new Map();
  (filas || []).forEach((fila) => {
    if (!fila?.insumoId) return;
    const insumo = insumosPrecargados[String(fila.insumoId)];
    costoTotal += Number(fila.cantidad || 0) * Number(insumo?.costo || 0);
    const totales = totalesFila(fila, insumosPrecargados, nivelPrecioId);
    if (!totales) {
      sinPrecio += 1;
      return;
    }
    subtotal += totales.subtotal;
    totales.desglose.forEach((imp) => {
      mapaImpuestos.set(
        imp.descripcionFactura,
        (mapaImpuestos.get(imp.descripcionFactura) || 0) + imp.totalImpuestos
      );
    });
  });
  const arrayImpuestos = [...mapaImpuestos].map(
    ([descripcionFactura, totalImpuestos]) => ({
      descripcionFactura,
      totalImpuestos,
    })
  );
  const totalImpuestos = arrayImpuestos.reduce(
    (acc, imp) => acc + imp.totalImpuestos,
    0
  );
  return {
    costoTotal,
    subtotal,
    arrayImpuestos,
    totalImpuestos,
    total: subtotal + totalImpuestos,
    sinPrecio,
  };
};

class ListaEscuelaModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    insumosPrecargados: {},
    versionApertura: 0,
    dataInicial: null,
    actualizarVentaOnline: false,
    librosVirtualesMarcados: {},
    empresaPrecios: [],
    nivelPrecioId: null,
    listaPrecioOriginal: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.cargarNivelesPrecio();

      if (this.props.lista?._id) {
        this.setState({
          insumosPrecargados: {},
          dataInicial: null,
          loading: true,
          actualizarVentaOnline: false,
          librosVirtualesMarcados: {},
        });
        this.consultarDatos(this.props.lista._id);
      } else {
        this.setState((prev) => ({
          insumosPrecargados: {},
          versionApertura: (prev.versionApertura || 0) + 1,
          actualizarVentaOnline: false,
          librosVirtualesMarcados: {},
          dataInicial: {
            nombre: "",
            descripcion: "",
            detalles: "",
            ocultarPrecios: false,
            paqueteCerrado: false,
            insumos: [
              { insumoId: undefined, cantidad: 1, requerido: false },
            ],
          },
        }));
      }
    }
  }

  esEdicion = () => Boolean(this.props.lista?._id);

  cargarNivelesPrecio = () => {
    axios
      .post(
        "listasEscuela/empresaPreciosParaPdfLista",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        const precios = res.data.empresaPrecios || [];
        const preciosOnlineId = res.data.preciosOnlineId
          ? String(res.data.preciosOnlineId)
          : null;
        const existeOnline = precios.some(
          (p) => String(p._id) === preciosOnlineId
        );
        const defaultNivel = existeOnline
          ? preciosOnlineId
          : precios.length > 0
          ? String(precios[0]._id)
          : null;
        this.setState({ empresaPrecios: precios, nivelPrecioId: defaultNivel });
      })
      .catch(() => {});
  };

  consultarDatos = (id) => {
    axios
      .post(
        "listasEscuela/datosListaEscuela",
        { listaId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.lista) {
          const {
            nombre,
            descripcion,
            detalles,
            insumos,
            listaPrecioId,
            ocultarPrecios,
            paqueteCerrado,
          } = res.data.lista;
          const precargados = {};
          for (const ins of res.data.insumos || []) {
            precargados[String(ins._id)] = ins;
          }
          const librosVirtuales = {};
          for (const item of insumos || []) {
            const insumoId = String(item.insumoId);
            if (precargados[insumoId]?.libroVirtual) {
              librosVirtuales[insumoId] = true;
            }
          }
          this.setState((prev) => ({
            loading: false,
            listaPrecioOriginal: listaPrecioId || null, 
            nivelPrecioId: listaPrecioId || prev.nivelPrecioId,
            insumosPrecargados: precargados,
            versionApertura: (prev.versionApertura || 0) + 1,
            librosVirtualesMarcados: librosVirtuales,
            dataInicial: {
              nombre,
              descripcion: descripcion || "",
              detalles: detalles || "",
              listaPrecioId: listaPrecioId ? String(listaPrecioId) : undefined,
              ocultarPrecios: !!ocultarPrecios,
              paqueteCerrado: !!paqueteCerrado,
              insumos: (insumos || []).length
                ? insumos
                : [{ insumoId: undefined, cantidad: 1, requerido: false }],
            },
          }));
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  onFinish = (values) => {
    if (!values?.nombre) {
      message.info("Ingresa el nombre de la lista");
      return;
    }
    
    const insumosLimpios = (values.insumos || [])
      .filter((i) => i?.insumoId)
      .map((i) => ({
        ...i,
        // Paquete cerrado: todo insumo se marca requerido, igual que hará el
        // backend al guardar (ver normalizarInsumosPorPaquete).
        requerido: values.paqueteCerrado ? true : !!i.requerido,
        esLibroVirtual: !!this.state.librosVirtualesMarcados[String(i.insumoId)],
      }));

    if (insumosLimpios.length === 0) {
      message.info("Agrega al menos un insumo");
      return;
    }

    const cambioListaPrecio =
      this.esEdicion() &&
      String(values.listaPrecioId || "") !== String(this.state.listaPrecioOriginal || "");

    if (cambioListaPrecio) {
      Modal.confirm({
        title: "Actualizar alumnos",
        content: "Se actualizará el P. E-Commerce a TODOS los alumnos que tengan asignada esta Lista Escolar. ¿Continuar?",
        okText: "Sí, actualizar",
        cancelText: "Cancelar",
        onOk: () => this.guardarLista(values, insumosLimpios),
      });
      return;
    }

    this.guardarLista(values, insumosLimpios);
  };

  guardarLista = (values, insumosLimpios) => {
    this.setState({ loading: true });

    const url = this.esEdicion()
      ? "listasEscuela/editarListaEscuela"
      : "listasEscuela/agregarListaEscuela";

    const payload = this.esEdicion()
      ? {
          listaId: this.props.lista._id,
          nombre: values.nombre,
          descripcion: values.descripcion || "",
          detalles: values.detalles || "",
          listaPrecioId: values.listaPrecioId || null,
          ocultarPrecios: !!values.ocultarPrecios,
          paqueteCerrado: !!values.paqueteCerrado,
          insumos: insumosLimpios,
          actualizarVentaOnline: this.state.actualizarVentaOnline,
        }
      : {
          empresaId: this.props.empresaId,
          nombre: values.nombre,
          descripcion: values.descripcion || "",
          detalles: values.detalles || "",
          listaPrecioId: values.listaPrecioId || null,
          ocultarPrecios: !!values.ocultarPrecios,
          paqueteCerrado: !!values.paqueteCerrado,
          insumos: insumosLimpios,
          actualizarVentaOnline: this.state.actualizarVentaOnline,
        };

    axios
      .post(url, payload, { headers: this.props.headersToken })
      .then(async (res) => {
        if (res.data.success === 2) {
          const listaIdGuardada = this.esEdicion()
            ? this.props.lista._id
            : res.data.listaId;

          if (this.props.grupoEscuelaId && listaIdGuardada) {
            try {
              await axios.post(
                "gruposEscuela/asignarListaGrupoEscuela",
                {
                  grupoEscuelaId: this.props.grupoEscuelaId,
                  listaId: listaIdGuardada,
                },
                { headers: this.props.headersToken }
              );
            } catch (e) {
              console.error("No se pudo ligar la lista al grupo", e);
            }
          }

          this.setState({ loading: false });
          message.success(
            this.esEdicion() ? "Lista actualizada exitosamente" : "Lista agregada exitosamente"
          );

          const actualizados = res.data.alumnosActualizados || 0;
          if (actualizados > 0) {
            message.info(
              `Se actualizó el P. E-Commerce de ${actualizados} alumno${
                actualizados === 1 ? "" : "s"
              }`
            );
          }

          this.cerrarModal(true);
        } else {
          this.setState({ loading: false });
          message.error("No se pudo guardar la lista");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  // Subtotal / impuestos / total de un renglón según la lista de precios
  // seleccionada. null = el insumo no tiene precio en esa lista.
  totalesDeFila = (fila) =>
    totalesFila(
      fila,
      this.state.insumosPrecargados,
      this.state.nivelPrecioId
    );

  cerrarModal = (recargar = false) => {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrarModal(recargar);
  };

  render() {
    const { dataInicial, loading, versionApertura, empresaPrecios } = this.state;
    const mostrarPrecios = empresaPrecios.length > 0;
    const isMobile = window.innerWidth <= 1000;
    const nivelPrecioNombre =
      empresaPrecios.find(
        (p) => String(p._id) === String(this.state.nivelPrecioId)
      )?.nombre || "";

    return (
      <ModalItem
        title={this.esEdicion() ? "Editar Lista" : "Agregar Lista"}
        visible={this.props.visible}
        spinning={loading}
        onCancel={() => this.cerrarModal(false)}
        width={mostrarPrecios ? 1000 : 800}
        paddingTop
      >
        {!dataInicial ? (

          <div style={{ minHeight: 120 }} />
        ) : (
        <Form
          key={`form-${versionApertura}`}
          ref={this.formRef}
          name="modalListaEscuela"
          layout
          initialValues={dataInicial}
          onFinish={this.onFinish}
          onFinishFailed={(e) => ErrorItem(e)}
        >
          <GeneralFormLayout
            isMobile={isMobile}
            totalesMaxWidth={isMobile ? "100%" : "420px"}
            cards={[
              {
                title: "Datos de la lista",
                lg: 12,
                xl: 12,
                content: (
                  <>
          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Nombre de la lista" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            margin
            tooltip="Descripción breve de esta lista (se mostrará al alumno/padre en el ecommerce)."
          >
            <InputItem placeholder="Descripción breve de la lista" />
          </FormItem>

          <FormItem
            name="detalles"
            label="Detalles"
            margin
            tooltip="Notas adicionales para el alumno/padre. Ej: 'Este insumo no lo vendemos, búscalo aparte.'"
          >
            <TextAreaItem
              rows={3}
              placeholder="Agrega notas u observaciones sobre los insumos de esta lista..."
            />
          </FormItem>
                  </>
                ),
              },
              {
                title: "Venta en línea y precios",
                lg: 12,
                xl: 12,
                content: (
                  <>
          <FormItem
            label="Actualizar todos para venta en línea"
            margin
            specialLayoutSwitch
            tooltip="Si está activo, al guardar la lista todos los insumos se pondrán disponibles para la venta en línea."
          >
            <SwitchItem
              checked={this.state.actualizarVentaOnline}
              onChange={(checked) =>
                this.setState({ actualizarVentaOnline: checked })
              }
            />
          </FormItem>

          <FormItem
            name="ocultarPrecios"
            label="Ocultar precios"
            margin
            specialLayoutSwitch
            valuePropName="checked"
            tooltip="Si está activo, el alumno no verá ningún precio de esta lista en el ecommerce (ni en la lista, ni en el carrito, ni en el resumen de la orden)."
          >
            <SwitchItem />
          </FormItem>

          <FormItem
            name="paqueteCerrado"
            label="Paquete cerrado"
            margin
            specialLayoutSwitch
            valuePropName="checked"
            tooltip="Si está activo, el alumno debe comprar la lista completa: no podrá excluir insumos ni quitarlos del carrito. Todos los insumos se marcarán como Requerido al guardar."
            getValueFromEvent={(checked) => {
              if (checked && this.formRef.current) {
                const insumosActuales =
                  this.formRef.current.getFieldValue("insumos") || [];
                this.formRef.current.setFieldsValue({
                  insumos: insumosActuales.map((i) => ({
                    ...i,
                    requerido: true,
                  })),
                });
              }
              return checked;
            }}
          >
            <SwitchItem />
          </FormItem>

          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) =>
              getFieldValue("paqueteCerrado") ? (
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 10 }}
                  message='Paquete cerrado: al guardar, todos los insumos de esta lista quedarán marcados como "Requerido".'
                />
              ) : null
            }
          </FormItem>

          {mostrarPrecios && (
            <FormItem
              name="listaPrecioId"
              label="Lista de precios"
              margin
              tooltip="Este es el P. E-Commerce de la lista: se guarda en la lista escolar y se aplica a sus alumnos. También se usa aquí para previsualizar el precio de cada insumo con los impuestos desglosados."
            >
              <Select
                value={this.state.nivelPrecioId}
                onChange={(v) => this.setState({ nivelPrecioId: v })}
                style={{ width: "100%" }}
                placeholder="Lista de precios"
              >
                {empresaPrecios.map((p) => (
                  <Select.Option key={String(p._id)} value={String(p._id)}>
                    {p.nombre}
                  </Select.Option>
                ))}
              </Select>
            </FormItem>
          )}
                  </>
                ),
              },
            ]}
            tabsConfig={{
              isMobile,
              tabs: [
                {
                  key: "insumos",
                  label: "Insumos",
                  forceRender: true,
                  customContent: (
                    <div
                      className="tabla-insumos-venta"
                      style={{ overflowX: "auto" }}
                    >
          <FormInitial.List
            name="insumos"
            initialValue={[{ insumoId: undefined, cantidad: 1, requerido: false }]}
          >
            {(fields, { add, remove, move }) => {
              const insumosSinVentaOnline = fields.reduce((acc, { name }) => {
                const fila =
                  this.formRef.current?.getFieldValue(["insumos", name]) || {};
                const insumo = fila.insumoId
                  ? this.state.insumosPrecargados[String(fila.insumoId)]
                  : undefined;
                return acc + (carecVentaOnline(insumo) ? 1 : 0);
              }, 0);
              return (
              <>
                {insumosSinVentaOnline > 0 && (
                  <Alert
                    type={this.state.actualizarVentaOnline ? "info" : "warning"}
                    showIcon
                    style={{ marginBottom: 10 }}
                    message={
                      this.state.actualizarVentaOnline
                        ? `${insumosSinVentaOnline} insumo(s) se pondrán para la venta en línea al guardar.`
                        : `${insumosSinVentaOnline} insumo(s) sin venta en línea: no aparecerán en el ecommerce de los alumnos.`
                    }
                  />
                )}
                <table className="table" style={{ width: "100%" }}>
                  {fields.length > 0 ? (
                    <thead>
                      <tr>
                        <th
                          className="th-border"
                          style={{ width: mostrarPrecios ? "34%" : "45%" }}
                        >
                          Insumo
                        </th>
                        <th
                          className="th-border"
                          style={{ width: mostrarPrecios ? "9%" : "11%" }}
                        >
                          Cantidad
                        </th>
                        {mostrarPrecios && (
                          <>
                            <th className="th-border" style={{ width: "11%" }}>
                              <Tooltip title="Precio unitario sin impuestos, según la lista de precios seleccionada.">
                                Precio U.
                              </Tooltip>
                            </th>
                            <th className="th-border" style={{ width: "13%" }}>
                              Subtotal / Imp. / Total
                            </th>
                          </>
                        )}
                        <th
                          className="th-border"
                          style={{ width: mostrarPrecios ? "9%" : "11%" }}
                        >
                          Requerido
                        </th>
                        <th
                          className="th-border"
                          style={{ width: mostrarPrecios ? "11%" : "14%" }}
                        >
                          Libro Virtual
                        </th>
                        <th
                          className="th-border"
                          style={{ width: mostrarPrecios ? "13%" : "19%" }}
                        ></th>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {fields.map(({ key, name, fieldKey, ...rest }) => {
                      const filaActual =
                        this.formRef.current?.getFieldValue([
                          "insumos",
                          name,
                        ]) || {};
                      const insumoPreCargado = filaActual.insumoId
                        ? this.state.insumosPrecargados[
                            String(filaActual.insumoId)
                          ]
                        : undefined;
                      const filaSinVentaOnline = carecVentaOnline(insumoPreCargado);
                      return (
                      <tr key={key}>
                        <td className="td-border">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <FormItem
                                {...rest}
                                name={[name, "insumoId"]}
                                fieldKey={[fieldKey, "insumoId"]}
                                required
                                noStyle
                                getValueFromEvent={(value, insumo) => {
                                  if (insumo?._id) {
                                    this.setState((prev) => ({
                                      insumosPrecargados: {
                                        ...prev.insumosPrecargados,
                                        [String(insumo._id)]: insumo,
                                      },
                                    }));
                                  }
                                  return value;
                                }}
                              >
                                <SelectInsumosItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  sinBorde
                                  dropdownMatchSelectWidth={500}
                                  width="100%"
                                  placeholder="Selecciona un insumo"
                                  tiposInsumos="venta"
                                  insumoPreCargado={insumoPreCargado}
                                />
                              </FormItem>
                            </div>
                            {filaSinVentaOnline && (
                              <Tooltip title="Este insumo no tiene activada la venta en línea. No aparecerá en el ecommerce de los alumnos.">
                                <WarningOutlined
                                  style={{ color: "#fa8c16", fontSize: 16 }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </td>
                        <td className="td-border">
                          <FormItem
                            {...rest}
                            name={[name, "cantidad"]}
                            fieldKey={[fieldKey, "cantidad"]}
                            initialValue={1}
                            noStyle
                            numberCero
                          >
                            <InputNumberItem sinBorde />
                          </FormItem>
                        </td>
                        {mostrarPrecios && (
                          <>
                            <td
                              className="td-border"
                              style={{ textAlign: "right" }}
                            >
                              <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                  const fila =
                                    getFieldValue(["insumos", name]) || {};
                                  const totales = this.totalesDeFila(fila);
                                  if (!fila.insumoId) return "—";
                                  if (!totales)
                                    return (
                                      <Tooltip title="Este insumo no tiene precio en esta lista de precios. Cuenta como $0.00 en los totales.">
                                        <span style={{ color: "#fa8c16" }}>—</span>
                                      </Tooltip>
                                    );
                                  return dineroDisabledMask(
                                    totales.precioUnitario
                                  );
                                }}
                              </FormItem>
                            </td>
                            <td
                              className="td-border"
                              style={{ textAlign: "right" }}
                            >
                              <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                  const fila =
                                    getFieldValue(["insumos", name]) || {};
                                  const totales = this.totalesDeFila(fila);
                                  if (!fila.insumoId || !totales) return "—";
                                  return (
                                    <div
                                      className="celda-totales"
                                      style={{ fontSize: "12px" }}
                                    >
                                      <div>
                                        {dineroDisabledMask(totales.subtotal)}
                                      </div>
                                      <div>
                                        {dineroDisabledMask(totales.impuestos)}
                                      </div>
                                      <div className="total-bold">
                                        Total:{" "}
                                        {dineroDisabledMask(totales.total)}
                                      </div>
                                    </div>
                                  );
                                }}
                              </FormItem>
                            </td>
                          </>
                        )}
                        <td className="td-border" style={{ textAlign: "center" }}>
                          <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                              const paqueteCerrado = getFieldValue("paqueteCerrado");
                              return (
                                <Tooltip
                                  title={
                                    paqueteCerrado
                                      ? "Este paquete es cerrado: todos los insumos son requeridos."
                                      : undefined
                                  }
                                >
                                  <FormItem
                                    {...rest}
                                    name={[name, "requerido"]}
                                    fieldKey={[fieldKey, "requerido"]}
                                    valuePropName="checked"
                                    initialValue={false}
                                    noStyle
                                  >
                                    <SwitchItem disabled={paqueteCerrado} />

                                  </FormItem>
                                </Tooltip>
                              );
                            }}
                          </FormItem>
                        </td>
                        <td className="td-border" style={{ textAlign: "center" }}>
                          <Tooltip
                            title={
                              insumoPreCargado?.lotesCaducidades
                                ? "Se le asignará un código único de lote al confirmarse el pago; dejará de aparecer para armado físico ('packing')."
                                : "Solo disponible para insumos con lotes y caducidades."
                            }
                          >
                            <SwitchItem
                              checked={
                                !!this.state.librosVirtualesMarcados[
                                  String(filaActual.insumoId || "")
                                ]
                              }
                              disabled={!insumoPreCargado?.lotesCaducidades}
                              onChange={(checked) =>
                                this.setState((prev) => ({
                                  librosVirtualesMarcados: {
                                    ...prev.librosVirtualesMarcados,
                                    [String(filaActual.insumoId)]: checked,
                                  },
                                }))
                              }
                            />
                          </Tooltip>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 8,
                            }}
                          >
                            <ArrowUpOutlined
                              onClick={() => name > 0 && move(name, name - 1)}
                              style={
                                name === 0
                                  ? { color: "#d9d9d9", cursor: "not-allowed" }
                                  : { color: "#13c2c2", cursor: "pointer" }
                              }
                            />
                            <ArrowDownOutlined
                              onClick={() =>
                                name < fields.length - 1 &&
                                move(name, name + 1)
                              }
                              style={
                                name === fields.length - 1
                                  ? { color: "#d9d9d9", cursor: "not-allowed" }
                                  : { color: "#fa8c16", cursor: "pointer" }
                              }
                            />
                            <MinusCircleOutlined
                              onClick={() => remove(name)}
                              style={{ color: "red", cursor: "pointer" }}
                            />
                          </div>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>

                <ButtonItem
                  type="dashed"
                  block
                  className="botonAgregar"
                  icon={<PlusOutlined />}
                  style={{ marginTop: 8 }}
                  onClick={() =>
                    add({ insumoId: undefined, cantidad: 1, requerido: false })
                  }
                >
                  Agregar Insumo
                </ButtonItem>
              </>
              );
            }}
          </FormInitial.List>
                    </div>
                  ),
                },
              ],
            }}
            observacionesConfig={{
              totales: (
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const {
                      costoTotal,
                      subtotal,
                      arrayImpuestos,
                      total,
                      sinPrecio,
                    } = calcularTotalesLista(
                      getFieldValue("insumos"),
                      this.state.insumosPrecargados,
                      this.state.nivelPrecioId
                    );
                    return (
                      <>
                        {mostrarPrecios && sinPrecio > 0 && (
                          <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 10 }}
                            message={`${sinPrecio} insumo(s) sin precio en la lista de precios "${nivelPrecioNombre}": cuentan como $0.00 en los totales.`}
                          />
                        )}
                          <table
                            className="table totales-table"
                            style={{ marginTop: 0, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  className="th-totales"
                                  style={{ width: "55%", fontSize: "14px" }}
                                >
                                  <Tooltip title="Suma del costo de los insumos por su cantidad. Las equivalencias no tienen costo propio, por lo que suman $0.00.">
                                    Costo total
                                  </Tooltip>
                                </th>
                                <td
                                  className="td-totales-right"
                                  style={{ width: "45%", fontSize: "14px" }}
                                >
                                  {dineroDisabledMask(costoTotal)}
                                </td>
                              </tr>
                            </tbody>

                            {mostrarPrecios && (
                              <>
                                <tbody>
                                  <tr>
                                    <th
                                      className="th-totales"
                                      style={{ fontSize: "14px" }}
                                    >
                                      Subtotal
                                    </th>
                                    <td
                                      className="td-totales-right"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {dineroDisabledMask(subtotal)}
                                    </td>
                                  </tr>
                                </tbody>

                                {arrayImpuestos.map((impuesto, index) => (
                                  <tbody key={index}>
                                    <tr>
                                      <th
                                        className="th-totales"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {impuesto.descripcionFactura}
                                      </th>
                                      <td
                                        className="td-totales-right"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {dineroDisabledMask(
                                          impuesto.totalImpuestos
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                ))}

                                <tbody>
                                  <tr>
                                    <th
                                      className="th-totales"
                                      style={{ fontSize: "16px" }}
                                    >
                                      Total
                                      {nivelPrecioNombre
                                        ? ` (${nivelPrecioNombre})`
                                        : ""}
                                    </th>
                                    <td
                                      className="td-totales-right"
                                      style={{ fontSize: "16px" }}
                                    >
                                      {dineroDisabledMask(total)}
                                    </td>
                                  </tr>
                                </tbody>
                              </>
                            )}
                          </table>
                      </>
                    );
                  }}
                </FormItem>
              ),
            }}
            actionButtons={
              <>
                <ButtonItem danger onClick={() => this.cerrarModal(false)}>
                  Cancelar
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  className="botonAgregar"
                  loading={this.state.loading}
                >
                  Guardar
                </ButtonItem>
              </>
            }
          />
        </Form>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ListaEscuelaModal);
